import { MutateOptions, useMutation } from '@tanstack/react-query';
import { SignupInput, SignupPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

export const useUserSignup = (
  options: MutateOptions<SignupPayload, TGenericError, SignupInput, unknown> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation userSignup($input: SignupInput!) {
      userSignup(input: $input) {
        errors
        errorCode
        success
      }
    }
  `;

  return useMutation<SignupPayload, TGenericError, SignupInput, unknown>({
    ...options,
    mutationFn: (input: SignupInput) =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      })
  });
};
